<template>
  <div id="contenedor-editar-fuentefinanciera">
    <v-form
      ref="editarFuenteFinanciera"
      v-model="esFormularioValido"
      >
      <v-card>
        <v-card-title class="secondary--text">
          Editar fuente financiera
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
          label="Nombre de la Fuente Financiera"
          v-model="fuenteFinanciera.nombre"
          :rules="[mixReglas.requerido]"
          v-on:keypress.enter="mixActualizarFuenteFinanciera"
          required
          >
          </custom-text-field>
          <custom-select
          label="Origen"
          :items="itemsorigen"
          v-model="fuenteFinanciera.origen"
          :rules="[mixReglas.requerido]"
          required
          >
          </custom-select>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarFuenteFinanciera"
            :disabled="!esFormularioValido"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoFuentesFinancieras from './mixCatalogoFuentesFinancieras';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosFuentesfinancierasEditar',
  mixins: [mixCatalogoFuentesFinancieras],
  props: {
    fuenteFinancieraEditar: Object,
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      itemsorigen: ['Estatal', 'Federal', 'Municipal', 'Privado', 'Mixto'],
      fuenteFinanciera: {
        nombre: this.fuenteFinancieraEditar.nombre,
        origen: this.fuenteFinancieraEditar.origen,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarFuenteFinanciera.reset();
    },
  },
};
</script>

<style>

</style>
